<router-outlet></router-outlet>
<ng-snotify></ng-snotify>
